import { useMemo } from "react";
import { createTheme, responsiveFontSizes } from "@mui/material/styles";

// color design tokens export
export const cobotColours = () => ({
  primary: {
    blue: "rgba(40, 53, 128, 1)",
    teal: "rgba(0, 165, 180, 1)",
    blend: "rgba(78, 135, 145, 1)",
    pink: "rgba(234, 173, 170, 1)",
    special: "rgba(0,125,133,0.26)",
    gradient: "linear-gradient(to right, primary.blue, primary.blend, primary.teal, primary.pink)",
  },
  secondary: {
    forest: "rgba(0, 95, 54, 1)",
    apple: "rgba(147, 213, 0, 1)",
    earth: "rgba(175, 203, 55, 1)",
    sun: "rgba(255, 213, 0, 1)",
    sky: "rgba(139, 51, 114, 1)",
    fire: "rgba(230, 51, 35, 1)",
  },
  grey: {
    lighter: "rgba(236,236,236,0.87)",
    light: "rgba(142, 142, 142, 1)",
    regular: "rgba(77, 77, 77, 1)",
    dark: "rgba(47, 47, 47, 1)",
    darker: "rgba(26, 26, 26, 1)",
  },
  text: {
    black: "#000000",
    white: "#FFFFFF",
  },
});

// mui theme settings
export const cobotThemeSettings = () => {
  const colors = cobotColours();
  return {
    palette: {

      primary: {
        main: colors.primary.blue,
      },
      secondary: {
        main: colors.primary.teal,
      },
      neutral: {
        dark: colors.grey.dark,
        main: colors.grey.regular,
        light: colors.grey.light,
      },
      background: {
        default: "#fcfcfc",
      },
        
    },
    typography: {
      fontFamily: ["Roboto",].join(','),
      fontSize: 14,
      h1: {
        fontFamily: "Roboto",
        fontSize: 64,
        fontWeight: "700",
        fontStyle: "normal",
      },
      h2: {
        fontFamily: "Roboto",
        fontSize: 56,
        fontWeight: "300",
        fontStyle: "italic",
      },
      h3: {
        fontFamily: "Roboto",
        fontSize: 40,
        fontWeight: "500",
        fontStyle: "normal",
      },
      h4: {
        fontFamily: "Roboto",
        fontSize: 32,
        fontWeight: "600",
        fontStyle: "normal",
      },
      h5: {
        fontFamily: "Roboto",
        fontSize: 24,
        fontStyle: "normal",
      },
      h6: {
        fontFamily: "Roboto",
        fontSize: 16,
        fontStyle: "normal",
      },
      body1: {
        fontFamily: "Roboto",
        fontSize: 16,
        fontWeight: "300",
        fontStyle: "normal",
      },
      body2: {
        fontFamily: "Roboto",
        fontSize: 14,
        fontWeight: "300",
        fontStyle: "normal",
      },
      // Custom variants as typography extensions
      extra: {
        fontFamily: "Roboto",
        fontSize: 88,
        fontWeight: "900",
        fontStyle: "normal",
      },
      date: {
        fontFamily: "Roboto",
        fontSize: 40,
        fontWeight: "500",
        fontStyle: "normal",
      },
    },
  };
};

export const useMode = () => {

  const cobotTheme = useMemo(() => responsiveFontSizes(createTheme(cobotThemeSettings()), []), []);
  return [cobotTheme];
};
